<div class="flex h-full w-full items-center justify-end">
  <button mat-icon-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened()" dojoStopPropagation>
    <dojo-icon icon="ellipsis" [class]="state.triggerIconClass" [size]="16" />
  </button>
</div>

<mat-menu #menu="matMenu">
  <y42-menu-option *ngFor="let option of state.options; trackBy: trackByLabel" [option]="option" />
</mat-menu>
